import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import LocalStorageService from "../../utils/auth_service/AuthServiceStorage";
import Dropdown from "bootstrap/js/dist/dropdown";

const FilterDropdown = ({ updateFilter, commentChecked }) => {
  const [filters, setFilters] = useState({
    noAction: true,
    approved: true,
    unresolved: true,
  });
 const localStorageService = LocalStorageService.getService();
   useEffect(() => {
    const filterData = localStorageService.getSelectedFilter();
    setFilters(JSON.parse(filterData || JSON.stringify({"noAction":true,"approved":true,"unresolved":true})));
   },[]);

  const [applyedFilters, setApplyedFilters] = useState({
    noAction: true,
    approved: false,
    unresolved: false,
  });

  const handleFilterChange = (filter) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filter]: !prevFilters[filter],
    }));
  };

  const applyFilters = () => {
    console.log("Applied Filters:", filters);
    if (commentChecked){
      toast.warn("Please Uncheck the Comment")
    }else{ updateFilter(filters);
      const toggleButton = document.getElementById("filterDropdown");
      if (toggleButton) {
        const dropdownInstance =
          Dropdown.getInstance(toggleButton) || new Dropdown(toggleButton);
        dropdownInstance.hide();
      }
    }
  };

    const reopenDropdown = () => {
  const toggle = document.getElementById("filterDropdown");
  const dropdownInstance = Dropdown.getInstance(toggle) || new Dropdown(toggle);
  dropdownInstance.show(); // 👈 opens the dropdown
};

  return (
    <div className="dropdown" style={{ width: "200px" }}>
      <button
        className="btn border-secondary dropdown-toggle"
        type="button"
        id="filterDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        data-bs-auto-close="outside"
        onClick={reopenDropdown}
      >
        Filter by:{" "}
        {filters.noAction
          ? "No Action "
          : filters.approved
          ? "Approved "
          : filters.unresolved
          ? "Unresolved "
          : ""}
        {filters.noAction && filters.approved && filters.unresolved
          ? "+2"
          : ((filters.noAction && filters.approved) ||
              (filters.noAction && filters.unresolved) ||
              (filters.approved && filters.unresolved)) &&
            "+1"}
      </button>
      <ul
        className="dropdown-menu p-3"
        // aria-labelledby="filterDropdown"
        aria-labelledby="dropdownMenuClickableInside"
      >
        <li>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="noAction"
              checked={filters.noAction}
              onChange={() => handleFilterChange("noAction")}
            />
            <label className="form-check-label" htmlFor="noAction">
              No Action
            </label>
          </div>
        </li>
        <li>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="approved"
              checked={filters.approved}
              onChange={() => handleFilterChange("approved")}
            />
            <label className="form-check-label" htmlFor="approved">
              Approved
            </label>
          </div>
        </li>
        <li>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="unresolved"
              checked={filters.unresolved}
              onChange={() => handleFilterChange("unresolved")}
            />
            <label className="form-check-label" htmlFor="unresolved">
              Unresolved
            </label>
          </div>
        </li>
        <li className="mt-2">
          <button
            className="btn btn-primary w-100"
            type="button"
            onClick={applyFilters}
          >
            Apply
          </button>
        </li>
      </ul>
    </div>
  );
};

export default FilterDropdown;
